import { render, staticRenderFns } from "./DhmeWkbPhaseChip.vue?vue&type=template&id=4b5b6619&scoped=true"
import script from "./DhmeWkbPhaseChip.vue?vue&type=script&lang=js"
export * from "./DhmeWkbPhaseChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b6619",
  null
  
)

export default component.exports